/**
 * The card pill (2.M deliverable 16, `header.pills.card`): a route link to the card form reading
 * `cardPillText`. It renders nothing unless `sheets` is on and the page is a live canon page whose
 * type has `has_card`.
 */
import { flagsFromMe, type SlotComponentProps } from '@codex/contracts';
import { Link } from '@tanstack/react-router';
import { useShellSession } from '../../shell/session.js';
import { useCard, useCardDoc } from './data/hooks.js';
import { cardPillText } from './model/pill.js';

export function CardPill({ docId }: SlotComponentProps) {
  const me = useShellSession();
  const on = me !== null && flagsFromMe(me).sheets;
  const cd = useCardDoc(docId, on);
  const shown = on && cd.editable;
  const card = useCard(docId, shown);
  if (!shown || card.data === undefined) return null;
  return (
    <Link
      to="/sheets/cards/$docId"
      params={{ docId }}
      className="cx-button cx-button--secondary cx-button--sm"
      data-testid="cards.header.pill"
    >
      <span className="cx-button__label">{cardPillText(card.data)}</span>
    </Link>
  );
}
